import React, { Component } from "react";
import {
  NavBar,
  Icon,
  List,
  DatePicker,
  Picker,
  InputItem,
  Button,
  WingBlank,
  WhiteSpace,
  TextareaItem,
  ActivityIndicator,
  Toast,
} from "antd-mobile";
import { createForm } from "rc-form";
import "./billExchange.scss";
import axios from "../../../service/axios";
import { formatTimeStamp, formatTimeStampSecond } from "@/utils/common";
const nowTimeStamp = Date.now();
const now = new Date(nowTimeStamp);

const type = [
  {
    label: "基础套餐",
    value: 0,
  },
  {
    label: "调度套餐",
    value: 1,
  },
  {
    label: "视频套餐",
    value: 2,
  },
];
const billTypes = [
  {
    label: "基础账单",
    value: 0,
  },
  {
    label: "续费账单",
    value: 1,
  },
];

const quotaTypeDatas = [
  {
    label: "基本额度",
    value: 0,
  },
  // {
  //   label: "VIP额度",
  //   value: 1
  // }
];

export class BillExchange extends Component {
  state = {
    date: now,
    endDate: new Date(),
    showToast: false,
    billType: 0,
    quotaType: 0,
  };

  onSubmit = () => {
    this.props.form.validateFields({ force: true }, error => {
      if (!error) {
        console.log(this.props.form.getFieldsValue());
        let filedsValue = this.props.form.getFieldsValue();
        let params = {
          billType: String(filedsValue.billType),
          quotaType: String(filedsValue.quotaType),
          type: String(filedsValue.type),
          number: Number(filedsValue.number),
          remarks: filedsValue.remarks,
          startDate: formatTimeStampSecond(now),
          endDate: formatTimeStampSecond(this.state.endDate),
        };
        console.log(params);
        this.setState({
          showToast: true,
        });
        axios
          .post("/api/bill/add", {
            ...params,
          })
          .then(res => {
            this.setState({
              showToast: false,
            });
            console.log(res);
            if (res) {
              if (res.status == 200) {
                Toast.success("置换账单成功!", 1.5, () => {
                  this.props.history.replace("/menu");
                });
              } else {
                Toast.fail(res.message);
              }
            }
          })
          .catch(err => {
            this.setState({
              showToast: false,
            });
            Toast.fail("置换账单失败!");
          });
      }
    });
  };
  componentDidMount() {
    var d2 = new Date();
    d2.setFullYear(d2.getFullYear() + 1);
    d2.setDate(d2.getDate() + 15);
    console.log(formatTimeStampSecond(d2));
    this.setState({
      endDate: d2,
    });
  }
  onChangeQuota = (rule, value, callback) => {
    console.log(value);
    this.setState({
      quotaType: value[0],
    });
    callback();
  };
  render() {
    const { getFieldProps, getFieldError } = this.props.form;
    const { billType, quotaType } = this.state;
    return (
      <div className="billExchange">
        <NavBar
          icon={<Icon type="left" />}
          onLeftClick={() => this.props.history.goBack()}
        >
          账单置换
        </NavBar>
        <div>
          <div>
            <ActivityIndicator
              toast
              text="正在处理..."
              animating={this.state.showToast}
            />
            <form>
              <List
                className="date-picker-list"
                renderFooter={() =>
                  getFieldError("quotaType") ||
                  getFieldError("type") ||
                  getFieldError("billType") ||
                  getFieldError("number") ||
                  getFieldError("remarks")
                }
              >
                <DatePicker
                  mode="date"
                  value={this.state.date}
                  {...getFieldProps("starteDate", {
                    rules: [{ required: true, message: "请选择开始时间" }],
                    initialValue: new Date(),
                  })}
                  disabled
                >
                  <List.Item arrow="horizontal">开始时间</List.Item>
                </DatePicker>

                <DatePicker
                  mode="date"
                  value={this.state.date}
                  {...getFieldProps("endDate", {
                    rules: [{ required: true, message: "请选择结束时间" }],
                    initialValue: this.state.endDate,
                  })}
                  disabled
                  format
                >
                  <List.Item arrow="horizontal">结束时间</List.Item>
                </DatePicker>
                <Picker
                  data={quotaTypeDatas}
                  cols={1}
                  {...getFieldProps("quotaType", {
                    rules: [
                      {
                        validator: this.onChangeQuota,
                      },
                    ],
                    initialValue: [0],
                  })}
                >
                  <List.Item arrow="horizontal">额度类型</List.Item>
                </Picker>
                <Picker
                  data={type}
                  cols={1}
                  {...getFieldProps("type", {
                    initialValue: [0],
                  })}
                >
                  <List.Item arrow="horizontal">套餐类型</List.Item>
                </Picker>
                <Picker
                  data={billTypes}
                  cols={1}
                  {...getFieldProps("billType", {
                    initialValue: [quotaType == 1 ? 1 : billType],
                  })}
                  disabled={quotaType == 1}
                >
                  <List.Item arrow="horizontal">账单类型</List.Item>
                </Picker>

                <InputItem
                  {...getFieldProps("number", {
                    rules: [
                      {
                        required: true,
                        message: "请填写要置换的额度值",
                      },
                    ],
                  })}
                  type="number"
                  clear
                  placeholder="请输入数字"
                >
                  额度值
                </InputItem>
                <TextareaItem
                  {...getFieldProps("remarks", {
                    // rules: [{ required: true, message: '请填写备注' }]
                  })}
                  title="备注"
                  placeholder="填写备注"
                  autoHeight
                />
              </List>
              <WhiteSpace size="xl" />
              <WingBlank>
                <Button type="primary" onClick={() => this.onSubmit()}>
                  额度换账单
                </Button>
              </WingBlank>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
export default createForm()(BillExchange);
